import React from 'react';

import { Flex, IconButton } from '@raystack/apsara';

import { RatingType } from '@src/clients/seeker/api';
import { ReactComponent as FilledThumbsDownIcon } from '@src/components/Sidebar/new_icons/filled-thumbs-down.svg';
import { ReactComponent as FilledThumbsUpIcon } from '@src/components/Sidebar/new_icons/filled-thumbs-up.svg';
import { ReactComponent as ThumbsDownIcon } from '@src/components/Sidebar/new_icons/thumbs-down.svg';
import { ReactComponent as ThumbsUpIcon } from '@src/components/Sidebar/new_icons/thumbs-up.svg';
import { Show } from '@src/hoc';
import { RATING_TYPES } from '@src/utils/constants/COPILOT_CONSTANTS';

interface FeedbackSectionProps {
  ratingStatus: RatingType;
  handleFeedbackClick: (rating: RatingType) => Promise<void>;
}

const FeedbackSection: React.FC<FeedbackSectionProps> = ({
  ratingStatus,
  handleFeedbackClick
}) => {
  const handleThumbClick = async (rating: RatingType) => {
    await handleFeedbackClick(rating);
  };

  const color = 'var(--rs-color-foreground-base-secondary)';
  return (
    <Flex direction='row' gap='small' align='center'>
      <IconButton
        size={3}
        data-test-id='thumbs-up'
        onClick={() =>
          handleThumbClick(
            ratingStatus === RATING_TYPES.POSITIVE
              ? RATING_TYPES.NEUTRAL
              : RATING_TYPES.POSITIVE
          )
        }
      >
        <Show
          when={ratingStatus === RATING_TYPES.POSITIVE}
          fallback={<ThumbsUpIcon color={color} />}
        >
          <FilledThumbsUpIcon color={color} />
        </Show>
      </IconButton>
      <IconButton
        size={3}
        data-test-id='thumbs-down'
        onClick={() =>
          handleThumbClick(
            ratingStatus === RATING_TYPES.NEGATIVE
              ? RATING_TYPES.NEUTRAL
              : RATING_TYPES.NEGATIVE
          )
        }
      >
        <Show
          when={ratingStatus === RATING_TYPES.NEGATIVE}
          fallback={<ThumbsDownIcon color={color} />}
        >
          <FilledThumbsDownIcon color={color} />
        </Show>
      </IconButton>
    </Flex>
  );
};

export default FeedbackSection;
